var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 107,
    viewBox: "0 0 108 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31,
    width: 76,
    height: 45,
    rx: 5,
    fill: "#FCF2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.0414 81.2949H13.9586C11.2627 81.2949 9.06836 79.1006 9.06836 76.4047V30.5953C9.06836 27.8994 11.2627 25.7051 13.9586 25.7051H94.0414C96.7373 25.7051 98.9316 27.8994 98.9316 30.5953V76.4256C98.9107 79.1006 96.7373 81.2949 94.0414 81.2949ZM13.9586 27.7531C12.3912 27.7531 11.1164 29.0279 11.1164 30.5953V76.4256C11.1164 77.993 12.3912 79.2678 13.9586 79.2678H94.0414C95.6088 79.2678 96.8836 77.993 96.8836 76.4256V30.5953C96.8836 29.0279 95.6088 27.7531 94.0414 27.7531H13.9586Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.021 61.3162C52.9551 61.3162 51.8893 60.9609 51.0116 60.2504L43.4672 54.2943L10.7821 28.5266C10.3432 28.1713 10.2596 27.5234 10.6149 27.0846C10.9702 26.6457 11.618 26.5621 12.0569 26.9174L44.7421 52.6852L52.3073 58.6412C53.3313 59.4563 54.7733 59.4563 55.8182 58.6412L63.3626 52.6852L96.0059 26.9174C96.4448 26.5621 97.0926 26.6457 97.4479 27.0846C97.8032 27.5234 97.7196 28.1713 97.2807 28.5266L64.5956 54.2943L57.0512 60.2504C56.1526 60.9818 55.0659 61.3162 54.021 61.3162Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6329 80.2918C96.403 80.2918 96.194 80.2082 96.0059 80.0619L63.3417 54.2941C62.9028 53.9389 62.8192 53.291 63.1745 52.8522C63.5297 52.4133 64.1776 52.3297 64.6165 52.685L97.3016 78.4527C97.7405 78.808 97.8241 79.4559 97.4688 79.8947C97.2389 80.1455 96.9464 80.2918 96.6329 80.2918Z",
    fill: "#0F0F0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3673 80.2918C11.0747 80.2918 10.7821 80.1664 10.5732 79.8947C10.2179 79.4559 10.3015 78.808 10.7403 78.4527L43.4046 52.685C43.8435 52.3297 44.4913 52.4133 44.8466 52.8522C45.2019 53.291 45.1183 53.9389 44.6794 54.2941L11.9942 80.0828C11.8062 80.2082 11.5972 80.2918 11.3673 80.2918Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailPic);
export default __webpack_public_path__ + "static/media/mail-pic.7ae2acfe827e1945352e53ba7f0b9a66.svg";
export { ForwardRef as ReactComponent };